
// IMPORTANT: When changing this enum, you have to change the equivalent enum in EmergencySituationInstructions.cs
export enum EmergencySituationInstructions {
  None = 0,
  Cpr = 1,
  Choking = 2,
  Unconsciousness = 3,
  Bleeding = 4,
  Nosebleeds = 5,
  GpsInstructionsIos = 6,
  GpsInstructionsAndroid = 7,
  CameraInstructionsIos = 8,
  CameraInstructionsAndroid = 9,
  ChildChoking = 10
}
